import { pdf, PDFViewer } from '@react-pdf/renderer';
import React, { useMemo, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import CetakSptPrimer from '../../../cetak/primer/CetakSptPrimer';
import UploadService from '../../../../services/transaksi/UploadService';
import SweetAlert from 'react-bootstrap-sweetalert';

const ModalCetakSpt = ({ showCetakSpt, handleCloseCetakSpt, rowData, uraianUpt }) => {

    let uploadService = useMemo(() => new UploadService(), [])

    const [loadingKirim, setLoadingKirim] = useState(false)
    const [showKirimSuccess, setShowKirimSuccess] = useState(false)
    const [showKirimFailed, setShowKirimFailed] = useState(false)
    const [showConfirmKirim, setShowConfirmKirim] = useState(false)
    const handleShowConfirmKirim = () => setShowConfirmKirim(true)
    const handleCloseConfirmKirim = () => setShowConfirmKirim(false)

    const handleClickKirimSuccess = () => {
        setLoadingKirim(false)
        setShowConfirmKirim(false)
        setShowKirimSuccess(false)
    }

    const handleClickKirimFailed = () => {
        setLoadingKirim(false)
        setShowConfirmKirim(false)
        setShowKirimFailed(false)
    }

    const kirimKePortal = async () => {
        setLoadingKirim(true)
        try {
            let filename = 'SPT-' + rowData.idIzin + '.pdf'
            const toBlob = await generatePdfToBlob()
            const formData = new FormData()
            formData.append('file', toBlob, filename)

            let urlFile = process.env.REACT_APP_API_URL_FILE + '/view/' + rowData.idIzin + '/' + filename

            const resUpload = await uploadService.uploadFileFormData(rowData.idIzin, formData)
            if (resUpload.status === 200) {
                let jsonPortal = {
                    filePath: urlFile,
                    idIzin: rowData.idIzin
                }
                console.log(jsonPortal)
                const resPortal = await uploadService.sendToPortal(JSON.stringify(jsonPortal))
                console.log(resPortal)
                setShowConfirmKirim(false)
                setShowKirimSuccess(true)
            }
        } catch (error) {
            setShowKirimFailed(true)
            console.log(error)
        }
        setLoadingKirim(false)
    }

    const generatePdfToBlob = async () => {
        const toblob = await pdf(<CetakSptPrimer rowData={rowData} uraianUpt={uraianUpt} />).toBlob()
        return toblob
    }

    return (
        <>
            <Modal
                show={showCetakSpt}
                onHide={handleCloseCetakSpt}
                keyboard={false}
                // scrollable={true}
                size='xl'
                centered
            >
                <Modal.Body>
                    <PDFViewer style={{ width: 1105, height: 750 }}>
                        <CetakSptPrimer rowData={rowData} uraianUpt={uraianUpt} />
                    </PDFViewer>
                </Modal.Body>
                <Modal.Footer>
                    {
                        rowData && rowData.stsTte === 0 &&
                        <Button variant="primary" size="sm" onClick={() => handleShowConfirmKirim()}>Kirim ke Portal</Button>
                    }{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseCetakSpt}>
                        Tutup
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmKirim &&
                <SweetAlert
                    title="Kirim SPT Ke Portal Untuk TTDE?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingKirim ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Kirim...
                            </>
                        ) : (
                            "Kirim"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={kirimKePortal}
                    onCancel={handleCloseConfirmKirim}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingKirim}
                >
                    {loadingKirim && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Kirim data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showKirimSuccess &&
                <SweetAlert
                    success
                    title="Kirim Data Berhasil"
                    onConfirm={handleClickKirimSuccess}
                    btnSize="sm"
                />
            }
            {
                showKirimFailed &&
                <SweetAlert
                    danger
                    title="Kirim Data Gagal"
                    onConfirm={handleClickKirimFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalCetakSpt